import { Card, Col, Skeleton, Flex, Row } from 'antd';

export const WorkflowItemHorizontalSkeleton = () => (
  <Card
    styles={{
      body: {
        borderRadius: 16,
        padding: 8,
      },
    }}
  >
    <Row gutter={16} align="top" wrap={false}>
      <Col flex="80px">
        <Skeleton.Image style={{ width: 60, height: 90, borderRadius: 8 }} active />
      </Col>
      <Col flex="25%">
        <Skeleton active paragraph={{ rows: 2 }} title={false} />
      </Col>
      <Col flex="35%">
        <Skeleton active paragraph={{ rows: 2 }} title={false} />
      </Col>
      <Col flex="">
        <Flex gap={8} align="start" style={{ paddingTop: 12, width: '100%' }}>
          <Skeleton.Button active style={{ width: 56, height: 56, borderRadius: 10 }} />
          <Skeleton.Button active style={{ width: 56, height: 56, borderRadius: 10 }} />
        </Flex>
      </Col>
    </Row>
  </Card>
);
